import { useEffect } from 'react';

import { DocumentSpecifiqueDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';

function useDeleteDocumentSpecifique(
  document: DocumentSpecifiqueDto | undefined,
  lastDeletionDate: number | undefined,
  setLastModificationDate: (lastDeletionDate: number) => void,
  closeModal: () => void,
) {
  const { AdminFonctionnelControllerApi: adminController } = useApi();

  useEffect(() => {
    if (!document) {
      closeModal();
      return;
    }
    adminController
      .deleteDocumentSpecifiqueUsingDELETE(document.id)
      .then(() => setLastModificationDate(Date.now()))
      .catch((error: Response) => {
        void backAlertMessage(error);
      })
      .finally(() => {
        closeModal();
      });
  }, [lastDeletionDate]);
}

export default useDeleteDocumentSpecifique;
